import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfOrderViewComponent } from './pdf-order-view.component';

const routes: Routes = [
  {
    path: '',
    component: PdfOrderViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfOrderViewRoutingModule { }
